import { useLocation, useNavigate } from "react-router-dom";
import '../components/requestProduct.css';
import { useState } from "react";

export default function DeleteAccount() {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const navigate = useNavigate();
    const location = useLocation();

    function home() {
        navigate('/');
    }
    function back() {
        // Check if there is a navigation history within the app
        if (location.key !== 'default') {
            navigate(-1); // Go back to the previous page
        } else {
            navigate('/'); // Redirect to the home page
        }
    }

    function isValidEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    const [requestText, setRequestText] = useState('');
    const [requestState, setRequestState] = useState(true);

    function handleRequest() {
        if (!isValidEmail(requestText)) {
            alert('Pls Enter valid email id.')
        } else if (requestState === '') {
            alert('Pls Write product name.')
        } else {
            setRequestState(false);
            const dataToSend = {
                searchItems: 'delete account - ' + requestText
            }
            fetch(`${BACKEND_URL}/search-items`, {
                method: 'post',
                headers: {
                    'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                    'content-type': 'application/json'
                },
                body: JSON.stringify(dataToSend),
            }).then((response) => response.json())
            .then((data) => {
                console.log(data)
            }).catch((error) => {
                console.log(error)
            })
        }
    }
    
    return (
        <>
            <div style={{display:'flex',flexDirection:'row', alignItems:'center'}}>
                <button className='arrow-back' onClick={back}>
                    <img src='/icons/left-arrow.png' alt='back-arrow' style={{height:'14px', width:'14px'}} />
                </button>
                <p className='coupon-head'>Account Deletion</p>
            </div>

            {
                requestState ? (
                    <div className="request-product-container">
                        <p className="request-product-desc-text">Please confirm that you want to delete your account. This action cannot be undone.</p>
                        <input
                            className="request-product-input"
                            placeholder="Enter Email ID"
                            value={requestText}
                            onChange={(e) => setRequestText(e.target.value)}
                        />
                        <div className="request-product-btn" onClick={handleRequest} style={{backgroundColor: 'red'}}><p className="request-product-btn-text">Delete account</p></div>
                    </div>
                ) : (
                    <div className="request-product-after-container">
                        <img src='/icons/success.png' alt='success' className="request-product-success-img"/>
                        <p className="request-product-after-desc-text">Your account deletion request has been received. Our team will process it shortly if account exist.</p>
                        <p className="request-product-go-home" onClick={home}>Go to Home</p>
                    </div>
                )
            }

        </>
    );
}